import {
  Box,
  BoxProps,
  Button,
  Checkbox,
  Flex,
  Heading,
  Image,
  Link,
  Text,
  useDisclosure,
} from '@chakra-ui/core';
import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons';
import React, { ReactNode } from 'react';
import BidenImage from '../../assets/biden.svg';
import TrumpImage from '../../assets/trump.svg';
import ResolutionDetailsModal from '../../components/ResolutionDetailsModal';

interface PartySelectionProps {
  selected: boolean;
  onSelect: () => void;
  image: string;
  label: ReactNode;
  checkboxProps?: BoxProps;
}

const PartySelection = ({
  selected,
  onSelect,
  image,
  label,
  checkboxProps,
  ...props
}: PartySelectionProps & any) => (
  <Box
    opacity={selected ? 1 : 0.5}
    {...props}
    onClick={onSelect}
    cursor="pointer"
    transition="opacity 0.25s linear"
    _hover={{ opacity: selected ? 1 : 0.75 }}
  >
    <Image src={image} mb={1} />
    <Checkbox isChecked={selected} size="sm" {...checkboxProps}>
      {label}
    </Checkbox>
  </Box>
);

const BetDetailsElection = ({ prediction, setPrediction, onBack, onNext }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <ResolutionDetailsModal
        isOpen={isOpen}
        onOpen={onOpen}
        onClose={onClose}
      />
      <Heading size="md" as="h4" textAlign="center" mb={8}>
        Which party will win the 2020 U.S. presidential election?
      </Heading>
      <Flex justifyContent="center" mb={8}>
        <PartySelection
          onSelect={() => setPrediction('republican')}
          image={TrumpImage}
          transform="translateX(20px)"
          selected={prediction === 'republican'}
          label={'Republican Party (Trump)'}
        />
        <PartySelection
          onSelect={() => setPrediction('democratic')}
          image={BidenImage}
          selected={prediction === 'democratic'}
          transform="translateX(-20px)"
          checkboxProps={{
            display: 'flex',
            flexDir: 'row-reverse',
          }}
          label={<Text mr="0.5rem">Democratic Party (Biden)</Text>}
        />
      </Flex>

      <Flex
        justifyContent="center"
        bg="#f5f6f9"
        borderRadius="4px"
        p={1}
        mx="auto"
        w="65%"
        fontSize="sm"
        fontWeight="500"
      >
        Resolution Details:
        <Link textDecor="underline" ml={2} color="blue.600" onClick={onOpen}>
          View Details
        </Link>
      </Flex>

      <Flex flexDir="row" mt={8}>
        <Button leftIcon={<ChevronLeftIcon />} onClick={onBack}>
          Go Back
        </Button>
        <Button
          ml="auto"
          colorScheme="blue"
          rightIcon={<ChevronRightIcon />}
          onClick={onNext}
          disabled={!prediction}
        >
          Next Step
        </Button>
      </Flex>
    </>
  );
};

const BetDetails = (props) => {
  return <BetDetailsElection {...props} />;
};

export default BetDetails;
